import React from 'react';
import PageContentLoading from '../../PageContentLoading';
import InviteCandidatesPageHeader from './InviteCandidatesPageHeader';
import { useInvitationPageContext } from './Contexts/InvitationPageContext';
import InviteCandidateContent from './InviteCandidateContent';
import Page from '@/Pages/Page';
import TopBar from '@/Components/TopBars/TopBar';

function AttractCandidatesPageContent(): React.JSX.Element {
    const { specsLoading, jobAdIdLoading } = useInvitationPageContext();

    return (
        <Page topBar={<TopBar />}>
            <InviteCandidatesPageHeader />
            <div className="flex flex-1 flex-col">
                <PageContentLoading isLoading={specsLoading || jobAdIdLoading} loadingFailed={false}>
                    <InviteCandidateContent />
                </PageContentLoading>
            </div>
        </Page>
    );
}

export default AttractCandidatesPageContent;
